import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetHelpDeskSacLinkPage, GetHelpDeskSacLinkPageModel} from 'domain/usecases';

export class RemoteGetHelpDeskSacLinkPage implements GetHelpDeskSacLinkPage {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHelpDeskSacLinkPageModel>,
	) {}

	async get(): Promise<GetHelpDeskSacLinkPageModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
